import type { PublicSiteLocaleOverride } from '../publicSiteTypes'

export const zhHansPublicSiteOverride = {
  content: {
    brand: {
      tagline: '灵动推进的计划',
    },
    routes: [
      { label: '概览', title: 'Timelining 应用', description: '一个视觉化规划工作区，结合积分经济、AI 审核流程和让计划保持活力的 RPG 循环。' },
      { label: '方案', title: '方案', description: '真实流程：发布、机构、创作者、学生、现场运营和学习小组。' },
      { label: '指南', title: '指南', description: '完整 walkthrough：从空工作区到已交付计划，覆盖每个界面、角色和流程。' },
      { label: '资源', title: '资源', description: '可直接复用的模式、AI 提示库、清单模板和工作节奏。' },
      { label: '价格', title: '价格', description: '积分经济定价。为实际消耗付费，而不是为席位付费。' },
      { label: '下载', title: '下载', description: '从公开下载页安装 Android Member 和 Helper 应用。' },
      { label: '关于', title: '关于', description: '为什么构建这个应用、它坚持什么、已经发布什么、接下来是什么。' },
      { label: 'FAQ', title: 'FAQ', description: '25 个问题，涵盖设置、AI、游戏化、团队和数据。' },
      { label: '联系', title: '联系', description: '联系试点、支持、反馈、演示和媒体合作。' },
    ],
    hero: {
      eyebrow: '视觉规划 · 积分经济 · AI 审核流程',
      headline: '让计划真正动起来',
      accent: '动起来',
      primaryCtaSignedOut: '开始使用',
      primaryCtaSignedIn: '打开工作区',
      secondaryCta: '阅读指南',
      consoleNoteSignedOut: '登录会进入私有应用体验。',
      consoleNoteSignedIn: '你已登录。继续当前工作区。',
    },
    ctaBand: {
      eyebrow: '准备好了吗？',
      title: '打开 Console，或获取应用。',
      primary: '打开 Console',
      secondary: '获取 APK',
    },
  },
  chrome: {
    nav: {
      ariaLabel: '公开网站导航',
      brandHomeSuffix: '主页',
      contact: '联系',
      getStarted: '开始',
      languageLabel: '语言',
      languageAriaLabel: '网站语言',
    },
    common: {
      openWorkspace: '打开工作区',
      openConsole: '打开 Console',
      featureColumnHeader: '功能',
      capabilityColumnHeader: '能力',
    },
    download: {
      eyebrow: '获取 Timelining',
      title: '安装 Android 应用。',
      downloadApk: '下载 APK',
      copyLink: '复制链接',
      share: '分享',
    },
  },
} satisfies PublicSiteLocaleOverride
